import React from 'react';

/**
 * This component is used for displaying
 * the common header and side navbar used
 * across various product lines in LT. This
 * also makes sure that the side navbar would
 * be in the mini view.
 */

const LambdaCommon = () => {
  return (
    <div id="lambda__header__wrapper">
      <header className="main__header__placeholder">
        <div title="Header" className="header__top__menu__placeholder">
          <div className="lambda__logo__wrapper__placeholder" />
        </div>
        <div title="Side Navbar" className="header__aside__menu__placeholder" />
      </header>
    </div>
  );
};

export default LambdaCommon;
